// extracted by mini-css-extract-plugin
module.exports = {"modal":"Modal-module__modal___scdJ2","dialogOverlay":"Modal-module__dialogOverlay___opO1f"};